import { authenticatedRestClient } from 'helpers/restclient';
import { getMasterOnBehalfOfHeader } from 'helpers/restclient/auth';

export default class PayMentMethodServices {
	static instance = new PayMentMethodServices();

	_endpoints = {
		getPaymentMethods: (vehicleId) => `/api/vehicles/${vehicleId}/payment_methods`,
		getSettingsPaymentMethod: `/api/settings/payment`,
		getSettingsPaymentMethodsList: `/api/settings/payment/methods`,
		updateSettingsDefaultPaymentMethod: `/api/settings/payment`,
		getAvailableSettingsFloorPlanCompanies: `/api/settings/payment/floorplans/available-companies`,
		addSettingsFloorPlan: `/api/settings/payment/floorplans`,
		createSettingsAch: '/api/create_ach',
		manualEntryViewed: '/api/manual_ach_entry_viewed',
		createSettingsPlaidLinkToken: '/api/plaid/link_token',
		createSettingsPlaidItem: '/api/plaid/items',
		updateSettingsPlaidItem: '/api/settings/payment/plaid/item',
		deleteSettingsPlaidItem: '/api/settings/payment/plaid/item',
		deleteSettingsManualAch: '/api/settings/payment/ach',
		handleSettingsPlaidLinkError: '/api/settings/payment/plaid/error_handler',
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	getPaymentMethods = (vehicleId, masterOnBehalfOf, cancelToken) => {
		let endpointURl = this._endpoints.getPaymentMethods(vehicleId);
		return this.restClient.get(endpointURl, {}, getMasterOnBehalfOfHeader(masterOnBehalfOf), cancelToken);
	};

	getSettingsPaymentMethod = (cancelToken) => {
		let endpointURl = this._endpoints.getSettingsPaymentMethod;
		return this.restClient.get(endpointURl, {}, {}, cancelToken);
	};

	getSettingsPaymentMethodsList = (cancelToken) => {
		let endpointURl = this._endpoints.getSettingsPaymentMethodsList;
		return this.restClient.get(endpointURl, {}, {}, cancelToken);
	};

	updateSettingsDefaultPaymentMethod = (payload, cancelToken) => {
		let endpointURl = this._endpoints.updateSettingsDefaultPaymentMethod;
		return this.restClient.patch(endpointURl, payload, {}, cancelToken);
	};

	getAvailableSettingsFloorPlanCompanies = (cancelToken) => {
		let endpointURl = this._endpoints.getAvailableSettingsFloorPlanCompanies;
		return this.restClient.get(endpointURl, {}, {}, cancelToken);
	};

	addSettingsFloorPlan = ({ floorPlanCompanyId, accountNumber }, cancelToken) => {
		let endpointURl = this._endpoints.addSettingsFloorPlan;
		const payload = {
			floor_plan_company_id: floorPlanCompanyId,
			...(accountNumber ? { account_number: accountNumber } : {}),
		};
		return this.restClient.post(endpointURl, payload, {}, cancelToken);
	};

	createSettingsAch = (payload, cancelToken) => {
		let endpointURl = this._endpoints.createSettingsAch;
		return this.restClient.post(endpointURl, payload, {}, cancelToken);
	};

	trackManualAchEntryViewed = (payload) => {
		return this.restClient.post(this._endpoints.manualEntryViewed, payload);
	};

	createSettingsPlaidLinkToken = (cancelToken) => {
		let endpointURl = this._endpoints.createSettingsPlaidLinkToken;
		return this.restClient.get(endpointURl, {}, {}, cancelToken);
	};

	createSettingsPlaidItem = (payload, cancelToken) => {
		let endpointURl = this._endpoints.createSettingsPlaidItem;
		return this.restClient.post(endpointURl, payload, {}, cancelToken);
	};

	updateSettingsPlaidItem = (payload, cancelToken) => {
		let endpointURl = this._endpoints.updateSettingsPlaidItem;
		return this.restClient.put(endpointURl, payload, {}, cancelToken);
	};

	deleteSettingsPlaidItem = (payload = {}, cancelToken) => {
		let endpointURl = this._endpoints.deleteSettingsPlaidItem;
		return this.restClient.delete(endpointURl, {}, payload, cancelToken);
	};

	deleteSettingsManualAch = (payload = {}, cancelToken) => {
		let endpointURl = this._endpoints.deleteSettingsManualAch;
		return this.restClient.delete(endpointURl, {}, payload, cancelToken);
	};

	handleSettingsPlaidLinkError = (payload, cancelToken) => {
		let endpointURl = this._endpoints.handleSettingsPlaidLinkError;
		return this.restClient.post(endpointURl, payload, {}, cancelToken);
	};
}
